import {ValueObject} from '@s-ui/domain'

import {ProfessionalActivityTransactionsEntity} from '../Entities/ProfessionalActivityTransactionsEntity.js'

export class ProfessionalActivitiesTransactionsValueObject extends ValueObject {
  /**
   * @param {Object} data
   * @param {Array<ProfessionalActivityEntity>} data.professionalActivities
   */

  constructor({professionalActivities = []}) {
    super()
    this._professionalActivities = professionalActivities
  }

  static create = ({professionalActivities}) => {
    const professionalActivitiesList = professionalActivities.map(professionalActivity => {
      return ProfessionalActivityTransactionsEntity.create({
        id: professionalActivity.id,
        description: professionalActivity.description
      })
    })

    return new ProfessionalActivitiesTransactionsValueObject({professionalActivities: professionalActivitiesList})
  }

  static fromApiResponse = (apiResponse = []) => {
    const professionalActivities = apiResponse.map(professionalActivityRawData => {
      return ProfessionalActivityTransactionsEntity.create({
        id: professionalActivityRawData.code,
        description: professionalActivityRawData.name
      }).toJSON()
    })

    return ProfessionalActivitiesTransactionsValueObject.create({professionalActivities})
  }

  toJSON() {
    return {
      professionalActivities: this._professionalActivities.map(professionalActivity => professionalActivity.toJSON())
    }
  }
}
